<div class="app-titulo-pagina">
    <span >Vales Presentes</span>
</div>

<div *ngIf="!mainService.parceiroService.getParceirosValePresente()"
     class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div class="container">
    <div *ngIf="mainService.parceiroService.getParceirosValePresente() === undefined">
        <p>Desculpe!</p>
        <p>Ainda não há Vales Presentes disponíveis para sua campanha!</p>
        <p>Caso tenha dúvidas, por favor entre em contato com nosso SAC!</p>
        <p>Obrigado!</p>
    </div>

    <div *ngIf="mainService.parceiroService.getParceirosValePresente() !== undefined">
        <a (click)="router.navigate(['/valepresente/cesta'])" class="btn app-btn-best">
            <i class="fa fa-shopping-basket"></i> Minha Cesta
        </a><br>
        <br>
        NOSSOS PARCEIROS POSSUEM AS MELHORES OPÇÕES DE VALES PRESENTES, CONFIRA:<br>
        <div class="col-xs-12 col-md-10 col-md-offset-1 text-center">
            <div class="parceiros" *ngFor="let parceiro of mainService.parceiroService.getParceirosValePresente()">
                <a
                   (click)="mainService.valePresenteService.visualizarVitrine(parceiro)"
                   class="text-center"
                   style="margin: 10px;">
                    <img [src]="parceiro.logotipo"
                         [alt]="parceiro.nome"
                         [id]="parceiro.nome">
                </a>
            </div>
        </div>
    </div>
</div>
<div class="clearfix"></div>


// WEBPACK FOOTER //
// ./src/app/vale-presente/parceiros/parceiros.component.html